/**
 * @file Helpers for deciding when to show the upload-started toast.
 */

import {
  UPLOAD_STARTED_TOAST_ASSUMED_BYTES_PER_SECOND,
  UPLOAD_STARTED_TOAST_MIN_ESTIMATED_DURATION_MS,
} from './constants';

/**
 * Estimates upload duration from total bytes using a conservative assumed speed.
 * @param totalBytes - Combined size of files in the enqueue batch.
 */
export const estimateUploadDurationMs = (totalBytes: number): number =>
  totalBytes <= 0
    ? 0
    : Math.ceil(
        (totalBytes / UPLOAD_STARTED_TOAST_ASSUMED_BYTES_PER_SECOND) * 1000
      );

/**
 * Whether the global upload-started toast should appear for this enqueue batch.
 * Skips tiny/fast uploads that would immediately be followed by a completion toast.
 */
export const shouldShowUploadStartedToast = (files: File[]): boolean =>
  estimateUploadDurationMs(files.reduce((sum, file) => sum + file.size, 0)) >=
  UPLOAD_STARTED_TOAST_MIN_ESTIMATED_DURATION_MS;
